import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { LocalizationActions } from '@nimbus-library/features/localization/store/localization.action';
import { TranslationsReadyService } from '@nimbus-library/features/localization/services/translations-ready.service';
import { AuthService } from './services/auth.service';
import { MessageService } from './services/message.service';
import { AppRoutes } from './enums/app-routes';
import { TrackingAssistantService } from './services/tracking/tracking.service';
import { TaskAudioNotificationsService } from './services/task-audio-notifications.service';
import { AppUpdateService } from './services/app-update.service';
import { TaskDirectCallService } from './services/task-direct-call.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription$: Subscription;
  public title = 'Notification Handler';
  public readonly translationsReady$: Observable<boolean>;

  public constructor(
    private readonly authService: AuthService,
    private readonly taskDirectCallService: TaskDirectCallService, // need to initialize
    private readonly messageService: MessageService, // need to initialize
    private readonly audioNotificationsService: TaskAudioNotificationsService, // need to initialize
    private readonly appUpdateService: AppUpdateService, // need to initialize
    private readonly router: Router,
    private readonly store: Store,
    private readonly trackingService: TrackingAssistantService,
    translationsReadyService: TranslationsReadyService,
  ) {
    this.subscription$ = new Subscription();
    this.translationsReady$ = translationsReadyService.translationsReady$;
  }

  public ngOnInit(): void {
    this.router.navigate([AppRoutes.login]);
    this.store.dispatch(new LocalizationActions.LoadLanguage());
    this.trackingService.initialize().then((subscription$) => this.subscription$.add(subscription$));
  }

  public ngOnDestroy(): void {
    this.authService.logout();
  }
}
